import './location.less'

import React from 'react'
import {LinkType, WysiwygType} from 'types'
import {style} from 'util/style'
import {Trusted} from 'util/trusted'
import {Title} from 'views/layout/title'
import {Theme} from 'views/theme'

const styles = style('location')

export type LocationType = {
	title?: string
	subtitle?: string
	text?: WysiwygType
	iframe: string
	link?: LinkType
}

export const Location: React.FC<LocationType> = ({
	title,
	subtitle,
	text,
	iframe,
	link
}) => {
	if (!iframe) return null
	const strippedIframe = iframe.replace(/(<p[^>]+?>|<p>|<\/p>)/gim, '')

	return (
		<div className={styles()}>
			<Theme.OuterContainer>
				<Theme.Container>
					<Title className={styles('top')} title={title} subtitle={subtitle} />
					<div className={styles('content')}>
						<div className={styles('content-left')}>
							{text && <Theme.Wysiwyg>{text}</Theme.Wysiwyg>}
							{link && (
								<Theme.Link
									to={link.url}
									className={styles('content-left-link')}
									mod="arrowlong"
								>
									<Theme.LinkText>
										{link.description || link.title}
									</Theme.LinkText>
									<Theme.LinkIcon icon="arrow-long" />
								</Theme.Link>
							)}
						</div>
						<div className={styles('content-right')}>
							<div className={styles('iframecontainer')}>
								<Trusted>{strippedIframe}</Trusted>
							</div>
						</div>
					</div>
				</Theme.Container>
			</Theme.OuterContainer>
		</div>
	)
}
